import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const SearchForm = ({ setMobileMenuOpen }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsAnimating(false), 500);
    return () => clearTimeout(timeout);
  }, [isAnimating]);

  const handleSearchInput = (e) => setSearchTerm(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.length > 0) {
      navigate(`/search?query=${searchTerm}`);
      if (setMobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    } else {
      setIsAnimating(true);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`w-full flex items-center transition-all duration-300 ${isAnimating ? 'animate-shake' : ''
        }`}
    >
      <div className="relative flex-grow">
        <input
          value={searchTerm}
          onChange={handleSearchInput}
          type="text"
          placeholder="Поиск товаров..."
          className="w-full py-3 pl-5 pr-14 rounded-full border border-gray-600 bg-gray-700 shadow-sm text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300"
        />
        <button
          type="submit"
          className="absolute right-1 top-1 bottom-1 w-12 bg-indigo-500 hover:bg-indigo-600 text-white rounded-full flex items-center justify-center shadow-md transition-colors duration-300"
        >
          <FiSearch className="text-xl" />
        </button>
      </div>
    </form>
  );
};

export default SearchForm;